<template>
  <v-btn
    fab
    large
    class="whatsapp-float"
    color="green"
    :href="whatsappLink"
    target="_blank"
  >
    <v-icon dark>mdi-whatsapp</v-icon>
  </v-btn>
</template>

<script>
export default {
  data() {
    return {
      phone: "+51917915824",
      message: "Hola, quisiera más información.",
    };
  },
  computed: {
    whatsappLink() {
      const msg = encodeURIComponent(this.message);
      return `https://wa.me/${this.phone}?text=${msg}`;
    },
  },
};
</script>

<style scoped>
.whatsapp-float {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  background-color: #25d366 !important; /* verde oficial WhatsApp */
  color: white !important; /* icono en blanco */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
}
</style>
